

const Loading = () => {
  return <></>;
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "fixed",
    backgroundColor: "rgba(256,256,256,.7)",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    zIndex: 1000,
  },
};

export default Loading;
